<form #form="ngForm">
    <app-form-group icon="citizenship" label="Nacionalidade" labelFor="idNacionalidade">
        <select name="idNacionalidade" id="idNacionalidade" class="form-control" [(ngModel)]="nacionalidade.idNacionalidade" (change)="onChangeNacionalidade()" appShowErrorMessages required>
            <option [ngValue]="undefined"> Selecione ...</option>
            <option *ngFor="let item of nacionalidades" [ngValue]="item.id">{{ item.descricao }}</option>
        </select>
    </app-form-group>

    <app-uf-cidade-select *ngIf="nacionalidade.isBrasileira" [(uf)]="nacionalidade.naturalDeUf" [(cidade)]="nacionalidade.naturalDe" (ufChange)="onChange()" (cidadeChange)="onChange()"></app-uf-cidade-select>
</form>